/* eslint-disable no-classname/no-classname-outside-designsystem */
import type { ReactNode } from 'react'

interface AssetVizTopToolbarProps {
  leadingContent?: ReactNode
  centerContent?: ReactNode
  trailingContent?: ReactNode
}

export function AssetVizTopToolbar({
  leadingContent,
  centerContent,
  trailingContent,
}: AssetVizTopToolbarProps) {
  return (
    <div className='pointer-events-none absolute inset-x-0 top-0 z-10 flex items-center gap-2 px-2 py-1.5'>
      <div className='pointer-events-auto flex min-w-0 flex-1 items-center justify-start gap-1'>
        {leadingContent}
      </div>
      <div className='pointer-events-auto flex shrink-0 justify-center'>
        {centerContent}
      </div>
      <div className='flex min-w-0 flex-1 justify-end'>
        <div className='pointer-events-auto flex min-w-0 items-center justify-end gap-1'>
          {trailingContent}
        </div>
      </div>
    </div>
  )
}
